var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-container" },
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          attrs: {
            action: "",
            "http-request": _vm.handleUploadForm,
            headers: _vm.myHeaders,
            "show-file-list": false,
            multiple: "",
          },
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "0px", "margin-bottom": "6px" },
              style: { background: _vm.color, borderColor: _vm.color },
              attrs: { icon: "el-icon-upload", size: "small", type: "primary" },
            },
            [_vm._v(" 上传图片")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }